/**
 * @generated SignedSource<<5a427e341004b1ff9916a875171dcad9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuthContextRefetchQuery$variables = Record<PropertyKey, never>;
export type AuthContextRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AuthContext_user">;
};
export type AuthContextRefetchQuery = {
  response: AuthContextRefetchQuery$data;
  variables: AuthContextRefetchQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthContextRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AuthContext_user"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthContextRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aacb985965130059e9d70d81a6c11cf1",
    "id": null,
    "metadata": {},
    "name": "AuthContextRefetchQuery",
    "operationKind": "query",
    "text": "query AuthContextRefetchQuery {\n  ...AuthContext_user\n}\n\nfragment AuthContext_user on Query {\n  me {\n    id\n    firstName\n    lastName\n    email\n  }\n}\n"
  }
};

(node as any).hash = "036619eb42b5cf77509a4ff7a3f74e2b";

export default node;
